import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "showIcon", "hideIcon"]

  toggle() {
    const isPassword = this.inputTarget.type === "password"
    this.inputTarget.type = isPassword ? "text" : "password"
    
    // After toggling:
    // - If we just switched TO text (was password), hide showIcon, show hideIcon
    // - If we just switched TO password (was text), show showIcon, hide hideIcon
    this.showIconTarget.classList.toggle("hidden", isPassword)
    this.hideIconTarget.classList.toggle("hidden", !isPassword)
  }
}
